import type { TextVariant } from './Text.variant';
export const textVariantClassMap: Record<TextVariant, string> = {
  h1: 'font-bold',
  h2: 'font-semibold',
  h3: 'font-semibold',
  h4: 'font-semibold',
  CardHeader: 'font-semibold',
  p: 'font-normal',
  pBold: 'font-semibold',
  pSmall: 'font-normal',
  list: 'font-normal',
  inlineCode: 'font-semibold',
  buttonLabel: 'font-semibold',
  buttonLabelSmall: 'font-semibold',
  badgeLabel: 'font-semibold',
  labelLarge: 'font-semibold',
  labelSemiLarge: 'font-semibold',
  label: 'font-semibold',
  labelReg: 'font-normal',
  labelSmall: 'font-semibold',
  labelSmallReg: 'font-normal',
  labelExSmall: 'font-normal',
  inputLabelLarge: 'font-normal',
  inputLabel: 'font-normal',
  numberSemiLarge: 'font-bold tabular-nums',
  blockquote: 'font-normal',
  tableHead: 'font-semibold',
  tableItem: 'font-normal',
  tableItemNumber: 'font-normal tabular-nums',
  numberLarge: 'font-bold tabular-nums',
  secret: 'font-normal'
} as const;